<template>
  <div class="docBody">
    <h1>Listare afecțiuni comune</h1><br />
    <p>Pentru a obține listarea afecțiunilor comune în format JSON, se utilizează apelul urmator:</p>
    <span class="get">GET</span> <kbd>http://www.apimedic.ro/api/v1/diseases</kbd>
    <p>Exemplu răspuns:</p>
    <code>[
    {
        "name": "Gripă",

        "description": "Gripa sezoniera este o infectie virala acuta...",
        
        "keywords": "fever, cold, flu, laryngitis, hoarseness, sneezing, runny nose, sore throat"
    },
    ...
  ]
  </code>
  <br /> <br />
  <p>Deși nu se poate observa în răspuns (omis pentru lizibilitate), descrierea unei afecțiuni conține mark-up HTML pentru o formatare corespunzătoare.</p>
  <p>O versiune simplificată (fără descriere) se poate obține prin urmatorul apel:</p>
  <span class="get">GET</span> <kbd>http://www.apimedic.ro/api/v1/diseases/short</kbd>
  <p>Exemplu răspuns:</p>
    <code>[
    {
        "name": "Gripă",
        "keywords": "fever, cold, flu, laryngitis, hoarseness, sneezing, runny nose, sore throat"
    },
    {
        "name": "Diabet",
        "keywords": "diabetes, cold feet, cold toes, urination, hand pain, insulin, thrist, tingling"
    },
    {
        "name": "Migrenă",
        "keywords": "headache, dizziness"
    },
    {
        "name": "HIV",
        "keywords": "hiv, aids"
    },
    {
        "name": "Depresie",
        "keywords": "depression, suicide"
    },
    {
        "name": "Astm",
        "keywords": "asthma"
    },
    {
        "name": "Colesterol",
        "keywords": "cholesterol"
    },
    ...
  ]
    </code>
  </div>
</template>

<script>
export default {
  name: 'ListDiseases'
}
</script>

<style scoped>
code{ color: black; }
</style>
